import api from '@/soluqr/api/client';

import { normalizeDeliveryGeocodeQuery } from './deliveryAddress';

/**
 * POST /menu/:businessId/geocode-address — geocodifica dirección vía backend (sin Maps JS en front).
 */
export async function requestMenuGeocodeAddress(businessId, address, options = {}) {
  const { signal } = options;
  const query = normalizeDeliveryGeocodeQuery(address);
  const { data } = await api.post(
    `/menu/${businessId}/geocode-address`,
    { address: query },
    signal ? { signal } : undefined
  );
  return data;
}
